<div class="example">
  <img src="/assets/img/visits/visits-zero-state.png" />
</div>
<div class="content">
  <h1 class="header">{{ "dashboard.noVisits.title" | translate }}</h1>
  <p class="text">{{ "dashboard.noVisits.text" | translate }}</p>
  <app-zero-view [datasource]="datasource"></app-zero-view>
</div>
